import Game from "./Game.js";
import gameData, { Coins, GameMode, MaxBillCoinData, getMaxBill, getMaxBills, getMaxCoin, getMaxCoins } from "../../gameData.js";
import InputHelper from "../../library/InputHelper.js";
import Dollar from "./Dollar.js";
import ABCyaLib from "@abcya/abcya_lib";
import Coin from "./Coin.js";

export default class Game_Counting extends Game
{
    create()
    {
        super.create();
        this.calculator = this.add.container(this.mid.x, 1200).setAlpha(0);

        this.addImage(0, 0, "Count_Tray", this.calculator);
        this.addImage(-180, -50, "AnsrScrn", this.calculator);

        this.addButton(-180, 18, "CountBtn_Chk", ()=>{
            this.numberSubmitted();
        }, this.calculator);

        this.decimalBtn = null;
        this.deleteBtn = null;
        this.numBtns = [];
        this.digitsEntered = "";

        this.config = ABCyaLib.Environment.instance.gameConfig;

        let btnSpacing = {
            x: -25, y: -50, spacingX: 59, spacingY: 67
        }
        let btns = ["CountBtn_1", "CountBtn_2", "CountBtn_3", "CountBtn_4", "CountBtn_5", "CountBtn_Dot", 
            "CountBtn_6", "CountBtn_7", "CountBtn_8", "CountBtn_9", "CountBtn_0", "CountBtn_Dlt"];
        
        for(let i = 0; i < 12; i++)
        {
            let x = i % 6, y = Math.floor(i/6), btnName = btns[i], onSelectFunc = null;
            let btn = this.addButton(btnSpacing.x + (btnSpacing.spacingX * x), btnSpacing.y + (btnSpacing.spacingY * y), btnName, ()=>{
                onSelectFunc(btnName.slice(btnName.length - 1));
            }, this.calculator);
            btn.soundKey = "enter_number";
            if(btnName == "CountBtn_Dlt") 
            {
                onSelectFunc = this.backSpacePressed.bind(this);
                this.deleteBtn = btn;
            }
            else if(btnName == "CountBtn_Dot") 
            {
                onSelectFunc = this.decimalAdded.bind(this);
                this.decimalBtn = btn;
                if(this.config.useCents){
                  this.decimalBtn.setVisible(false);
                }
            }
            else
            {
                onSelectFunc = this.digitAdded.bind(this);
                this.numBtns.push(btn);
            }
        }

        this.numberField = this.addText(-180, -52, 24, 0x83BD05, gameData.fonts.comfortaa_bold, this.config.useCents? "¢" : "$", this.calculator, true);
        this.checkButtons();
        
        InputHelper.Listen(InputHelper.KeyCodes.SPACE, ()=>{
            this.addTween(this.calculator, 300, {y: 1200, alpha: 0});
            this.answerCorrect();
        });
    }

    digitAdded(digit)
    {
        this.checkText();
        this.digitsEntered += digit;
        this.numberField.text = this.config.useCents ? (this.digitsEntered + "¢") : ("$" + this.digitsEntered);
        this.checkButtons();
    }

    decimalAdded()
    {
        this.checkText();
        this.digitsEntered += isNaN(this.calcValue) ? "0." : ".";
        this.numberField.text = this.config.useCents ? (this.digitsEntered + "¢") : ("$" + this.digitsEntered);
        this.checkButtons();
    }

    backSpacePressed()
    {
        this.checkText();
        this.digitsEntered = this.digitsEntered.slice(0, this.digitsEntered.length-1);
        this.numberField.text = this.config.useCents ? (this.digitsEntered + "¢") : ("$" + this.digitsEntered);
        this.checkButtons();
    }

    checkText()
    {
        this.killTween(this.numberField);
        if(this.numberField.text == "TRY AGAIN")
        {
            this.numberField.alpha = 1;
            this.numberField.text = this.config.useCents? "¢" : "$";
        }
    }

    checkButtons()
    {
        let txt = this.numberField.text;

        this.decimalBtn.setEnabled(txt.indexOf(".") == -1);
        this.deleteBtn.setEnabled(txt.length > 1);

        let digitsEnabled = (this.decimalBtn.input.enabled || txt.indexOf(".") > txt.length -3) && (this.config.useCents ? txt.length < 3 : txt.length < 12);
        if(!digitsEnabled) this.decimalBtn.setEnabled(false);
        this.numBtns.forEach((btn)=>{btn.setEnabled(digitsEnabled)})
    }

    get calcValue() { return Number.parseFloat(this.digitsEntered); }

    numberSubmitted()
    {
        let enteredValue = this.calcValue;
        if(this.config.useCents){
          enteredValue /=100;
        }
        if(enteredValue == this.totalValue)
        {
            this.addTween(this.calculator, 300, {y: 1200, alpha: 0});
            this.answerCorrect();
        }
        else 
        {
            this.playSound("incorrect_counting");
            this.digitsEntered = "";
            this.addTween(this.numberField, 100, {alpha: 0}, Phaser.Math.Easing.Sine.InOut, ()=>{
                this.numberField.text = "TRY AGAIN";
                this.addTween(this.numberField, 500, {alpha: 1, yoyo: true}, Phaser.Math.Easing.Sine.InOut, ()=>{
                    this.numberField.text = this.config.useCents? "¢" : "$";
                    this.addTween(this.numberField, 100, {alpha: 1}, Phaser.Math.Easing.Sine.InOut);
                    this.checkButtons();
                });
            });
        }
    }

    pigExploded()
    {
        this.addTween(this.calculator, 300, {alpha: 1});
        this.addTween(this.calculator, 1000, {y: 700, easeParams: [0, 1]}, "Elastic");
    }

    spawnMoney()
    {
      // if the restrictions object is null, use the original game functionality (in base Game.js)
      if(this.config.restrictions === null)
      {
        super.spawnMoney();
        return;
      }

        let bill = new Dollar(this, this.mid.x, 100, gameData.dollarData[1]).setAlpha(0);
        let minX = bill.minX + 100;
        let xDiff = bill.maxX - minX;
        let yDiff = bill.maxY - bill.minY;
        let billdestinations = [];
        const maxBills = getMaxBills();
        for(let y = 0; y < maxBills/2; y++)
        {
            for (let x = 0; x < 2; x++) 
            {
                let deltaX = x/1;
                let deltaY = y/(Math.ceil(maxBills/2)-1);
                billdestinations.push({x: minX + (deltaX * xDiff), y: bill.minY + (deltaY * yDiff)})
            }
        }
        bill.destroy();

        const question = this.generateQuestion();
        const numberOfBills = question[1]+question[5]+question[10]+question[20];
        let billPosition = numberOfBills-1;
        let index = 0;

        for(let key in question)
        {
          if(gameData.coinData[key]){
            const coinData = gameData.coinData[key];
            const coinSpawns = question[key];
            for (let i = 0; i < coinSpawns; i++) {                
              let coin = new Coin(this, this.mid.x, 100, coinData).setPosition(this.mid.x, this.mid.y).setScale(coinData.scale);

              this.addTween(coin, 200, { x: Phaser.Math.Between(coin.minX, coin.maxX), y: Phaser.Math.Between(coin.minY, coin.maxY) }, Phaser.Math.Easing.Sine.Out);
              this.addDropShadow(coin, 3, 3, coinData.sprite);
              this.addDelay(i*10 + 40, ()=>{ coin.setDepth(3).shadow.setDepth(3); });

              this.money.push(coin);
              this.totalValue += coinData.value;
            }
          }
          else if(gameData.dollarData[key]){
            const billData = gameData.dollarData[key];
            const billSpawns = question[key];
            for (let i = 0; i < billSpawns; i++) {
              let bill = new Dollar(this, this.mid.x, 100, billData).setPosition(this.mid.x, this.mid.y).setScale(1);

              this.addDropShadow(bill, 5, 5, billData.sprite);
              this.addTween(bill, 200, { x: billdestinations[billPosition].x, y: billdestinations[billPosition].y }, Phaser.Math.Easing.Sine.Out);
              this.addDelay(index*10 + 40, ()=>{ bill.setDepth(2).shadow.setDepth(2); });
            
              billPosition--;
              index++;

              this.money.push(bill);
              this.totalValue += billData.value;
            }
          }
        }

        this.totalValue = this.totalValue.toFixed(2);
    }

    generateQuestion()
    {        
        const currency = [
          {name: GameMode.Pennies, value: 0.01, maxNum: getMaxCoin(GameMode.Pennies)},
          {name: GameMode.Nickels, value: 0.05, maxNum: getMaxCoin(GameMode.Nickels)},
          {name: GameMode.Dimes, value: 0.1, maxNum: getMaxCoin(GameMode.Dimes)},
          {name: GameMode.Quarters, value: 0.25, maxNum: getMaxCoin(GameMode.Quarters)},
          {name: GameMode.Ones, value: 1, maxNum: getMaxBill(GameMode.Ones)},
          {name: GameMode.Fives, value: 5, maxNum: getMaxBill(GameMode.Fives)},
          {name: GameMode.Tens, value: 10, maxNum: getMaxBill(GameMode.Tens)},
          {name: GameMode.Twenties, value: 20, maxNum: getMaxBill(GameMode.Twenties)},
        ];
        
        const maxBills = getMaxBills();
        const maxCoins = getMaxCoins();
        const maxValue = MaxBillCoinData.maxValue;
      
        const addCurrency = (currency, maxValue, currentValue, remaining) => {
          const valueDiff = maxValue - currentValue;
          const maxNum = Math.min(Math.floor(valueDiff/currency.value), currency.maxNum, remaining);
          const rndNum = Math.round(Math.random() * maxNum);
          return {
            name: currency.name,
            num: rndNum,
            value: rndNum * currency.value,
          }
        }
      
        let currentValue = 0;
        let remainingBills = maxBills > 0 ? Phaser.Math.Between(1, maxBills) : 0;
        let remainingCoins = maxCoins > 0 ? Phaser.Math.Between(1, maxCoins) : 0;
        
        let questionData = {};
        Phaser.Utils.Array.Shuffle(currency);
        while (currentValue == 0){
          currency.forEach(c => {
            const rndCurrency = c;
            const addedCurrency = addCurrency(rndCurrency, maxValue, currentValue, (Coins & rndCurrency.name) != 0 ? remainingCoins : remainingBills);
            currentValue += addedCurrency.value;
            questionData[addedCurrency.name] = addedCurrency;
            if((Coins & rndCurrency.name) != 0) remainingCoins -= addedCurrency.num;
            else remainingBills -= addedCurrency.num;
          });
        }
        
        return {
          20: questionData[GameMode.Twenties].num,
          10: questionData[GameMode.Tens].num,
          5: questionData[GameMode.Fives].num,
          1: questionData[GameMode.Ones].num,
          quarter: questionData[GameMode.Quarters].num,
          dime: questionData[GameMode.Dimes].num,
          nickel: questionData[GameMode.Nickels].num,
          penny: questionData[GameMode.Pennies].num
        }
    }
}